export const WAVELIGHTS = () => `/wavelights`;
export const EDIT_WAVELIGHTS = (id: string) => `/wavelights/edit/${id}`;
export const WAVELIGHT_WAVES = (id: string) => `/wavelights/waves/${id}`;
export const WAVELIGHT_WAVES_ITEMS = (id: string, wid: string) =>
  `/wavelights/waves/${id}/wave/${wid}`;
export const WAVELIGHT_WAVES_TECHNIQUES = (id: string, wid: string) =>
  `/wavelights/waves/${id}/wave/${wid}/techniques`;
export const WAVELIGHT_WAVES_TECHNIQUES_ITEM = (
  id: string,
  wid: string,
  tid: string,
) => `/wavelights/waves/${id}/wave/${wid}/techniques/${tid}`;
